import React from "react"
import R from "../../constants/routes"

export const Home: React.FunctionComponent = () => {
  window.location.replace(R.unifiedHome)
  return null
}

export default Home
